import { useState } from "react";
import { Button, Typography } from "@app/ui-kit";
import { FEW, fewNamed } from "../lib/fewNamed";

/**
 * A sentence that names the first few of a list and counts the rest, with the rest one click away. Renders nothing for
 * an empty list. `prefix` ends the way the caller wants it ("No answered question yet: "), `suffix` closes the sentence.
 */
export const FewNamed = ({ items, prefix = "", suffix = ".", testId, color = "text.secondary", variant = "body2" }: { items: readonly string[]; prefix?: string; suffix?: string; testId?: string; color?: string; variant?: "body2" | "caption" }) => {
  const [open, setOpen] = useState(false);
  if (items.length === 0) return null;
  return (
    <Typography variant={variant} color={color} data-testid={testId}>
      {prefix}{open ? items.join(", ") : fewNamed(items)}{suffix}
      {items.length > FEW && <Button size="small" variant="text" onClick={() => setOpen((o) => !o)} aria-expanded={open} sx={{ minWidth: 0, p: 0, ml: 0.75, fontSize: "inherit", lineHeight: "inherit", verticalAlign: "baseline" }}>{open ? "Show fewer" : `Show all ${items.length}`}</Button>}
    </Typography>
  );
};
